import { createStore, withProps } from '@ngneat/elf';
import { SelectOption } from '../../components/form-builder/form-builder.types';
import { DynamicForm, DynamicFormDto, DynaStatus } from '@/types';

export interface DynamicFormProps {
  response?: DynamicForm;
  dto: DynamicFormDto;
  typeSelected: SelectOption;
  formTypeSelected: SelectOption;
  errors: Record<string, any>;
}

export const dynamicFormInitialState: DynamicFormProps = {
  dto: {
    id: 0,
    name: '',
    order: undefined,
    typeDossierId: undefined,
    formType: undefined,
    status: DynaStatus.NON_ACTIF,
    fields: [],
  },
  typeSelected: { name: '', code: undefined },
  formTypeSelected: { name: '', code: undefined },
  errors: {},
};

export const dynamicFormStore = createStore({ name: 'dynamic-form-state' }, withProps<DynamicFormProps>({ ...dynamicFormInitialState }));
